import uploadBlue from "assets/img/upload-blue.svg";
import loadingSvg from "assets/img/loading.svg";
import Base64Logo from "components/Base64Logo";
import Button from "components/Button";
import { Card, CardList } from "components/Card";
import CSVDownload from "components/CSVDownload";
import Dropzone from "components/Dropzone";
import Icon from "components/Icon";
import Table from "components/Table";
import Config from "config";
import { RouteProps } from "containers/App";
import CreateBreadcrumb from "containers/CreateBreadcrumb";
import FileUpload from "containers/FileUpload";
import ManageDataPreview from "containers/ManageDataPreview";
import React from "react";
import Popover from "components/DeletePopover";
import { connect, ConnectedProps } from "react-redux";
import { State } from "state";
import { updateChain, deleteChain, createChain } from "state/chain";
import { fetchChains } from "state/chains";
import { buildExportFilename, getTemplateHeaders } from "utils/helpers";
import ChainFilter from "./ChainFilter";
import CSVDownload3 from "../components/CSVDownload3";
import Modal from "../components/LightThemeModal";
import { fetchParentChains } from "../state/parentChains";
import moment from "moment";
import Constants from "../helpers/constants";
import { Store } from "../interfaces/store";
import { LightThemeTable } from "../components/LightThemeTable";
import FileEditorModal from "components/FileEditorModal";
import Loader from "components/Loader";
import { SeverityLevel, ToastService } from "../services/toastService";

const styles = {
  container: { background: "#fff", padding: 10, borderRadius: 10 },
  header: { fontFamily: "Poppins, sans-serif", fontWeight: 600, fontSize: 14, marginBottom: 15 },
  button: (bg: string, color: string, border: string = "none") => ({
    padding: "5px 15px",
    border,
    borderRadius: 4,
    backgroundColor: bg,
    color,
    cursor: "pointer",
    fontSize: 12,
    fontWeight: 600,
  }),
  input: { width: "100%", padding: 8, borderRadius: 16, border: "1px solid #ccc", fontSize: 12 },
  modalFooter: { display: "flex", justifyContent: "flex-end", marginTop: 15 },
  confirmFooter: { display: "flex", justifyContent: "center", gap: 20 },
};
type ManageChainsProps = PropsFromRedux & RouteProps;
class ManageChains extends React.Component<ManageChainsProps> {
  state = {
    tableData: [],
    chainId: 0,
    popoverOpenId: null,
    pendingChainDeletionId: -1,
    errorMessage: null,
    chain_parent_id: -1,
    name: "",
    keycontact1: "",
    keycontact2: "",
    keycontact3: "",
    cid: "",
    showModal: false,
    showErrors: false,
    editChain: { id: -1 },
    allChains: [],
    isContinuebtnDisplay: false,
    showWarningModal: false,
    fileEditorOpen: false,
    fileEditorFile: null,
    fileEditorError: null,
    isLoading: true,
    isAwaitingCreation: false,
  };

  protected CSV_HEADERS = [
    { label: "Chain Name", key: "name" },
    { label: "Channel", key: "channel" },
    { label: "Feedback Limit", key: "feedbacklimit" },
    { label: "Key Contact 1", key: "keycontact1" },
    { label: "Key Contact 2", key: "keycontact2" },
    { label: "Key Contact 3", key: "keycontact3" },
    { label: "Chain Parent", key: "chain_parent" },
    { label: "Catalyst ID", key: "cid" },
  ];

  public onDrop = (files: any[], chainId: number) => {
    const [file] = files;
    if (file) {
      const data = new FormData();
      data.append("file", file);

      this.props.updateChain(chainId, data).then(() => {
        this.props.fetchChains();
      });
    }
  };

  public componentDidMount() {
    this.props.fetchChains();
    this.props.fetchParentChains(1, 100000);
  }

  public componentDidUpdate(prevProps: ManageChainsProps) {
    if (prevProps.chains?.content !== this.props.chains?.content) {
      this.setState({
        isLoading: false,
      });
    }
  }

  public handleDelete = (chain: any) => {
    this.setState({
      pendingChainDeletionId: chain.id,
      showWarningModal: true,
      errorMessage: `Are you sure you want to delete ${chain.name}?`,
      isContinuebtnDisplay: true,
    });
  };

  public handleDeleteConfirmation = async (chainId: number) => {
    if (chainId >= 0) {
      this.setState({ isAwaitingCreation: true });
      await this.props.deleteChain(chainId).then(() => {
        this.setState({ isAwaitingCreation: false, showWarningModal: false });
      });;

      if (this.props.chain.error) {
        this.setState({
          errorMessage:
            "Something went wrong and unable to delete because it was already associated with Stores and it's user.",
          pendingChainDeletionId: null,
          showWarningModal: true,
          isContinuebtnDisplay: false,
        });
      } else {
        this.setState({ isLoading: true });
        await this.props.fetchChains();
        this.setState({ isLoading: false });

        const errorMessage = this.props.chains.error
          ? "Deletion succeeded. However, something went wrong when fetching new chain list."
          : ToastService.getInstance().publishToast(
            {
              identifier: "success-operation",
              title: "Success",
              message: "Store deleted successfully!",
            },
            SeverityLevel.SUCCESS,
            { autoClose: 3000 }
          );
        this.setState({
          errorMessage,
          pendingChainDeletionId: null,
          showWarningModal: !!this.props.chains.error,
          isContinuebtnDisplay: false,
        });
      }
    }
  };

  resetForm = () =>
    this.setState({
      chain_parent_id: -1,
      name: "",
      keycontact1: "",
      keycontact2: "",
      keycontact3: "",
      cid: "",
      editChain: { id: -1 },
    });

  handleCreateNew = () => {
    this.setState({ showModal: true, editingStore: { id: -1 } }, this.resetForm);
  };

  handleInputChange =
    (field: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      let value = e.target.value;

      // Field-specific validation (only cid = numeric only)
      if (field === "cid") {
        value = value.replace(/[^0-9]/g, "");
      }

      this.setState({ [field]: value });
    };

  handleSaveNew = async () => {
    const { chain_parent_id, name } = this.state;

    if (this.isDuplicateChainName()) {
      this.setState({
        showWarningModal: true,
        errorMessage:
          "A chain with this name already exists under the selected Chain Parent.",
        isContinuebtnDisplay: false, 
        isAwaitingCreation: false,
      });
      return;
    }
    this.setState({ isAwaitingCreation: true });

    const { keycontact1, keycontact2, keycontact3, cid, editChain } = 
      this.state;
    if (editChain && editChain?.id >= 0) {
      this.props
        .updateChain(editChain.id, {
          chain_parent_id,
          name,
          keycontact1,
          keycontact2,
          keycontact3,
          cid,
          editChain,
        })
        .then(() => {
          this.props.fetchChains();
          this.resetForm();
          this.setState({
            isAwaitingCreation: false,
            showModal: false,
          });
        });
    } else {
      this.props
        .createChain({ chain_parent_id, name, keycontact1, keycontact2, keycontact3, cid })
        .then(() => {
          this.props.fetchChains();
          this.resetForm();
          this.setState({
            isAwaitingCreation: false,
            showModal: false,
          });
        });
    }
  };

  isDuplicateChainName = () => {
    const { chain_parent_id, name, editChain } = this.state;
    const { chains } = this.props;

    if (!chains?.content) return false;

    return chains.content.some((chain: any) =>
      chain.chain_parent_id === Number(chain_parent_id) &&
      chain.name?.trim().toLowerCase() === name.trim().toLowerCase() &&
      chain.id !== editChain?.id
    );
  };


  handleEdit = (id: number, chain: any) => {
    this.resetForm();

    this.setState({
      editChain: { id: id },
      chain_parent_id: chain.chain_parent_id,
      name: chain.name ? chain.name : "",
      keycontact1: chain.keycontact1 ? chain.keycontact1 : "",
      keycontact2: chain.keycontact2 ? chain.keycontact2 : "",
      keycontact3: chain.keycontact3 ? chain.keycontact3 : "",
      cid: chain.cid ? chain.cid : "",
      showModal: true,
    });
  };

  public handleUploadError = (error: any, uploadedFile: File) => {
    // Extract error message from different possible error formats

    console.log("handleUploadError triggers", error);

    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Upload failed. Please review and correct the file.";

    this.setState({
      fileEditorOpen: true,
      fileEditorFile: uploadedFile,
      fileEditorError: errorMessage,
    });
  };

  public handleFileEditorClose = () => {
    this.setState({
      fileEditorOpen: false,
      fileEditorFile: null,
      fileEditorError: null,
    });
  };

  public handleFileEditorSuccess = async () => {
    // Refresh the store list after successful edit upload
    // await this.props.fetchStores();
    // this.updateTableData();
    this.props.fetchChains();
    this.handleFileEditorClose();
  };

  public render() {
    const columns = [
      {
        field: "name",
        header: "Chains",
      },
      { field: "chain_parent", header: "Chain Parent" },
      { field: "keycontact1", header: "Key Contact1" },
      { field: "keycontact2", header: "Key Contact2" },
      { field: "keycontact3", header: "Key Contact3" },
      { field: "projects", header: "Projects" },
      {
        field: "actions",
        header: "Actions",
        minWidth: 110,
        formatter: (_: any, row: Store) => (
          <div style={{ display: "flex", justifyContent: "flex-start", gap: 12 }}>
            <button
              onClick={() => this.handleEdit(row.id, row)}
              style={{ background: "none", border: "none", cursor: "pointer", padding: 2 }}
            >
              <img
                src={require("../assets/img/Edit.png")}
                alt="Edit"
                style={{ display: "block" }}
              />
            </button>
            <button
              onClick={() => this.handleDelete(row)}
              style={{ background: "none", border: "none", cursor: "pointer", padding: 2 }}
            >
              <img
                src={require("../assets/img/Delete.png")}
                alt="Delete"
                style={{ display: "block" }}
              />
            </button>
          </div>
        ),
      },
    ];
    let label = "USER ROLE CHAIN";
    const {
      showModal,
      chain_parent_id,
      name,
      keycontact1,
      keycontact2,
      keycontact3,
      cid,
      editChain,
      fileEditorOpen,
      fileEditorFile,
      fileEditorError,
      isLoading,
      isAwaitingCreation,
    } = this.state;
    const { parentChains } = this.props;
    const sortedChains = parentChains.sort((a, b) => a.name.localeCompare(b.name));

    return (
      <section className="manage-data-container">
        <CreateBreadcrumb
          crumbs={{
            crumbs: [
              {
                to: "/manage-all-data",
                crumb: "VIEW ALL DATA",
                dataQa: "view-all-data-link",
              },
            ],
          }}
        />
        <div className="manage-data-body">
          <div className="upload-section-3">
            <h4 >Upload / Update Chain Data</h4>
            <div>
              <CSVDownload
                data={[]}
                headers={this.CSV_HEADERS}
                filename={buildExportFilename("csv", `chains`)}
              >
                <div className="file-upload-header">Download CSV Template</div>
              </CSVDownload>
            </div>
            <FileUpload
              prefix={"CHAINS"}
              url={`${Config.API_SERVICE_URL}/api/chains`}
              label={""}
              dataQa={"manage-chains-file-upload"}
              afterUploadFunction={this.props.fetchChains}
              onUploadError={this.handleUploadError}
            />
          </div>

          {/*<ul className="file-upload-list">*/}
          {/*  <li className="file-upload-item">*/}

          {/*  </li>*/}

          {/*</ul>*/}
          <CardList>
            <Card>
              <ManageDataPreview prefix={"CHAINS"} />
            </Card>
          </CardList>
          {/* {this.props.chain.error && <div className="error">{this.state.errorMessage}</div>} */}
          <div className="manage-data-table-controls" data-qa="chain-dropdown">
            <div></div>
            <div className="action-btns">
              <div>
                <CSVDownload3
                  data={this.props.chains.content}
                  headers={this.CSV_HEADERS}
                  filename={buildExportFilename("csv", "chains")}
                  disabled={!this.props.chains.content}
                ></CSVDownload3>
              </div>
              <div>
                <button
                  className="primary-button"
                  onClick={this.handleCreateNew}
                >
                  Create Chain
                </button>
              </div>
            </div>
          </div>
          <div>
            <Modal
              show={showModal}
              onClose={() => this.setState({ showModal: false, showErrors: false })}
              title={editChain?.id >= 0 ? "Edit Chain" : "Create Chain"}
              width="800px"
              closeOnBackdropClick={false}
              footer={
                <div style={styles.modalFooter}>
                  <div style={{ display: 'flex' }}>
                    <div style={{ display: 'flex', marginRight: '5px' }}>
                      {isAwaitingCreation && (<Loader height={20} width={20} custom={true} ></Loader>)}
                    </div>
                    <button
                      onClick={() => {
                        const isValid = chain_parent_id && name.trim();

                        if (!isValid) {
                          this.setState({ showErrors: true });
                          return;
                        }
                        this.setState({ showErrors: false }, () => {
                          this.handleSaveNew();
                        });
                      }}
                      style={{
                        padding: "6px 12px",
                        borderRadius: 4,
                        background: "#E5B42F",
                        color: "#fff",
                        border: "none",
                        fontSize: 12,
                        fontWeight: 600,
                        cursor: "pointer",
                        minWidth: "72px",
                        //marginLeft: "5px",
                      }}
                    >
                      {!isAwaitingCreation ? 'Submit' : 'Submitting'}
                    </button>
                  </div>
                </div>
              }
            >
              <div style={{ display: "flex", gap: 20, marginBottom: 15, fontSize: 12 }}>
                <div style={{ flex: 1 }}>
                  <label>
                    Chain Parent <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    value={this.state.chain_parent_id < 0 ? "" : this.state.chain_parent_id}
                    onChange={this.handleInputChange("chain_parent_id")}
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: this.state.showErrors && chain_parent_id < 0 ? "#ffe6e6" : "#fff",
                      padding: "10px",
                      color: chain_parent_id < 0 ? "#999" : "#000",
                    }}
                  >
                    {chain_parent_id < 0 && (
                      <option value="" disabled>
                        Select Chain Parent
                      </option>
                    )}
                    {sortedChains.map((channel) => (
                      <option key={channel.id} value={channel.id}>
                        {channel.name}
                      </option>
                    ))}
                  </select>
                  {this.state.showErrors && chain_parent_id < 0 && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                </div>
                <div style={{ flex: 1 }}>
                  <label>
                    Chain Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={name}
                    onChange={this.handleInputChange("name")}
                    placeholder="Enter First Name"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: (this.state.editChain && this.state.editChain['id'] >= 0)
                        ? "#f0f0f0" : this.state.showErrors && !name ? "#ffe6e6" : "#fff",
                    }}
                    disabled={editChain && editChain['id'] >= 0 ? true : false}
                  />
                  {this.state.showErrors && !name && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                </div>
                <div style={{ flex: 1 }}>
                  <label>Key Contact1</label>
                  <input
                    type="text"
                    value={keycontact1}
                    onChange={this.handleInputChange("keycontact1")}
                    placeholder="Enter Key Contact1"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: "#fff",
                    }}
                  />
                </div>
              </div>
              <div style={{ display: "flex", gap: 20, marginBottom: 15, fontSize: 12 }}>
                <div style={{ flex: 1 }}>
                  <label>Key Contact2</label>
                  <input
                    type="text"
                    value={keycontact2}
                    onChange={this.handleInputChange("keycontact2")}
                    placeholder="Enter Key Contact2"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: "#fff",
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label>Key Contact3</label>
                  <input
                    type="text"
                    value={keycontact3}
                    onChange={this.handleInputChange("keycontact3")}
                    placeholder="Enter Key Contact3"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: "#fff",
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label>Catalyst Id</label>
                  <input
                    type="text"
                    value={cid}
                    onChange={this.handleInputChange("cid")}
                    placeholder="Enter Catalyst Id"
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: "#fff",
                    }}
                  />
                </div>
              </div>
            </Modal>
          </div>
          <div>
            <Modal
              show={this.state.showWarningModal}
              onClose={() => this.setState({ showWarningModal: false })}
              title=""
              width="400px"
              footer={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 10,
                    paddingTop: 10,
                  }}
                >
                  <div style={{ width: '7%', paddingTop: '3px' }}>
                    {this.state.isAwaitingCreation && (<Loader height={20} width={20} custom={true} ></Loader>)}
                  </div>
                  {!this.state.isContinuebtnDisplay && (
                    <button
                      onClick={() => this.setState({ showWarningModal: false })}
                      style={{
                        padding: "6px 16px",
                        borderRadius: 4,
                        border: "none",
                        background: "#E5B42F",
                        color: "#000",
                        cursor: "pointer",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      OK
                    </button>
                  )}

                  {this.state.isContinuebtnDisplay && (
                    <button
                      onClick={() => this.setState({ showWarningModal: false })}
                      style={{
                        padding: "6px 16px",
                        borderRadius: 4,
                        border: "none",
                        background: "#E5B42F",
                        color: "#000",
                        cursor: "pointer",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      Cancel
                    </button>
                  )}

                  {this.state.isContinuebtnDisplay && (
                    <button
                      onClick={() =>
                        this.setState({}, () =>
                          this.handleDeleteConfirmation(this.state.pendingChainDeletionId)
                        )
                      }
                      style={{
                        padding: "6px 16px",
                        borderRadius: 4,
                        border: "none",
                        background: "#E5B42F",
                        color: "#000",
                        cursor: "pointer",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                      disabled={this.state.isAwaitingCreation}
                    >
                      Yes, Continue
                    </button>
                  )}
                </div>
              }
            >
              <p style={{ marginBottom: 20, color: "#555", fontSize: 12 }}>
                <strong>{this.state.errorMessage}</strong>
              </p>
            </Modal>
          </div>
          <CardList>
            <Card>
              {/*<Table*/}
              {/*  data={this.props.chains.content as object[]}*/}
              {/*  columns={[*/}
              {/*    {*/}
              {/*      field: "name",*/}
              {/*      header: "CHAIN",*/}
              {/*      dataQa: "chain_name",*/}
              {/*      minWidth: 100,*/}
              {/*      formatter: (value, row) => {*/}
              {/*        return (*/}
              {/*          <div*/}
              {/*            style={{*/}
              {/*              display: "flex",*/}
              {/*              alignItems: "center",*/}
              {/*            }}*/}
              {/*          >*/}
              {/*            <Dropzone*/}
              {/*              className="chain-image-dropzone"*/}
              {/*              data-qa={`update-chain-image-btn-${value}`}*/}
              {/*              accept={"image/*"}*/}
              {/*              onDrop={(files: File[]) => this.onDrop(files, row.id)}*/}
              {/*            >*/}
              {/*              <Icon src={uploadBlue} />*/}
              {/*            </Dropzone>*/}
              {/*            <Base64Logo data={row.logo} data-qa={`${value}-logo`}  logo_filename={row.logo_filename}/>*/}
              {/*            {value && <span style={{ marginLeft: 10 }}>{value}</span>}*/}
              {/*          </div>*/}
              {/*        );*/}
              {/*      },*/}
              {/*    },*/}
              {/*    {*/}
              {/*      field: "channel",*/}
              {/*      header: "CHANNEL",*/}
              {/*      dataQa: "chain_channel",*/}
              {/*    },*/}
              {/*    {*/}
              {/*      field: "keycontact1",*/}
              {/*      header: "KEY CONTACT 1",*/}
              {/*      dataQa: "chain_keycontact1",*/}
              {/*    },*/}
              {/*    {*/}
              {/*      field: "keycontact2",*/}
              {/*      header: "KEY CONTACT 2",*/}
              {/*      dataQa: "chain_keycontact2",*/}
              {/*    },*/}
              {/*    {*/}
              {/*      field: "keycontact3",*/}
              {/*      header: "KEY CONTACT 3",*/}
              {/*      dataQa: "chain_keycontact3",*/}
              {/*    },*/}
              {/*    {*/}
              {/*      field: "feedbacklimit",*/}
              {/*      header: "FEEDBACK LIMIT",*/}
              {/*      dataQa: "chain_feedbacklimit",*/}
              {/*    },*/}
              {/*    {*/}
              {/*      field: "",*/}
              {/*      header: "",*/}
              {/*      sortable: false,*/}
              {/*      dataQa: "delete-chain",*/}
              {/*      maxWidth: 80,*/}
              {/*      formatter: (row: any, index: number) => {*/}
              {/*        return (this.state.pendingChainDeletionId === row.id) ?*/}
              {/*          <img className="spin-right" src={loadingSvg} alt="Loading Icon" /> :*/}
              {/*          <Popover*/}
              {/*            message={"Delete this chain"}*/}
              {/*            id={row.id}*/}
              {/*            index={index}*/}
              {/*            onConfirm={(id) => this.handleDelete(row.id)}*/}
              {/*            buttonStyles={{paddingLeft: 0, paddingRight: 15}}*/}
              {/*          />*/}
              {/*      },*/}
              {/*    },*/}
              {/*  ]}*/}
              {/*/>*/}
              <div style={{ margin: "1%" }}>
                <LightThemeTable data={this.props.chains.content as []} columns={columns} isLoading={isLoading} />
              </div>
            </Card>
          </CardList>
        </div>

        <FileEditorModal
          isOpen={fileEditorOpen}
          file={fileEditorFile}
          error={fileEditorError}
          prefix="CHAINS"
          config={{
            prefix: "CHAINS",
            url: `${Config.API_SERVICE_URL}/api/chains`,
            onUploadSuccess: this.handleFileEditorSuccess,
          }}
          onClose={this.handleFileEditorClose}
        />
      </section>
    )
  }
}

const connecter = connect(
  (state: State) => ({
    chains: state.chains,
    chain: state.chain,
    parentChains: state.parentChains.content,
  }),
  {
    fetchChains,
    updateChain,
    deleteChain,
    fetchParentChains,
    createChain,
  }
);

type PropsFromRedux = ConnectedProps<typeof connecter>;

export default connecter(ManageChains);
